import { createContext } from 'react';
import { EnhancedInterestResponse } from '../../services/api/interest/interest-model-definitions.ts';
import { AdSourceType } from '@pages/Root/ContextWrapper/WithInterest/WithCommonPageData.tsx';

export const EMPTY_INTERESTS = new EnhancedInterestResponse({
  gen: '',
  interests: [],
  status: {
    http: 0,
    lkbk: '',
  },
  ttl: '',
});

export interface CommonPageData {
  interests: EnhancedInterestResponse;
  brandGroupId: string;
  utmSource: string;
  appVersion?: string;
  partner?: string;
  advId?: string;
  adSource: AdSourceType;
  appBundle?: string;
  appName?: string;
  numberOfPages?: number;
  shuffleSeed: string;
  LOCATION_API_BASE_URL: string;
}

export const CommonPageDataContext = createContext<CommonPageData>({
  interests: EMPTY_INTERESTS,
  brandGroupId: '',
  utmSource: '',
  adSource: 'gam',
  numberOfPages: 4,
  shuffleSeed: '0',
  LOCATION_API_BASE_URL: '',
});
